<template>
    <b-card :header="header" id="tipo-sim">

        <b-row>
            <b-col md="12" class="mb-4">
                <b-form-group label="¿Cuántos números desea comprar? *">
                    <b-input-group class="number-of-lines-holder">
                        <b-input-group-prepend>
                            <b-button @click="form.numberOfLines > 1 ? form.numberOfLines-- : 1"
                                variant="outline-primary">-</b-button>
                        </b-input-group-prepend>
                        <b-form-input v-model="form.numberOfLines" type="number" min="1" />
                        <b-input-group-append>
                            <b-button @click="form.numberOfLines++" variant="outline-primary">+</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="¿Qué formato de entrega deseas?">
                    <b-button-group>
                        <b-button :variant="form.deliveryFormat === 'physical' ? 'primary' : 'outline-primary'"
                            @click="form.deliveryFormat = 'physical'">
                            Entrega física
                        </b-button>
                        <b-button :variant="form.deliveryFormat === 'virtual' ? 'secondary' : 'outline-primary'"
                            @click="form.deliveryFormat = 'virtual'">
                            Entrega virtual (eSIM)
                        </b-button>
                    </b-button-group>
                </b-form-group>
            </b-col>
        </b-row>

        <div class="text-center mt-4" v-if="form.deliveryFormat === 'virtual'">


            <b-jumbotron class="text-left" bg-variant="info" text-variant="white">
                <template v-slot:header>Importante</template>
                <template v-slot:lead>
                    Debes confirmar que tus dispositivos sean compatibles con la tecnología eSIM.
                </template>

                <b-form-group class="mt-3">
                    <b-form-checkbox v-model="form.deviceCompatibilityConfirmed">
                        Confirmo que mi dispositivo es compatible con la tecnología eSIM.*
                    </b-form-checkbox>
                </b-form-group>

                <hr>

                <b-button variant="secondary" @click="$bvModal.show('compatibility-modal')"
                    v-if="compatModeActivator == 'button'" class="mt-3">
                    {{ compatibilidadLabel }}
                </b-button>
                <p v-else="compatModeActivator == 'link-like'" class="call-out">
                    * Si no estas seguro 
                    <span class="link-like" @click="$bvModal.show('compatibility-modal')">verifica aquí</span> 
                    si tu equipo soporta eSIM
                </p>

                <b-modal id="compatibility-modal" :title="compatibilidadLabel" hide-footer
                    content-class="bg-dark text-white">
                    <!-- <p>Por favor, asegúrate de que tu dispositivo sea compatible con la tecnología eSIM antes de continuar.</p> -->
                    <compatibility-imei no-desc specify-by-e-sim />
                    <!-- <b-button variant="primary" @click="$bvModal.hide('compatibility-modal')">Cerrar</b-button> -->
                </b-modal>

                <!-- <b-button variant="secondary" href="#" @click="$router.push({ name: 'compatibilidad' })" class="mt-3">
                    Confirmar compatibilidad
                </b-button> -->
            </b-jumbotron>

        </div>

    </b-card>
</template>

<script>
import contrataYa from './contrataYa';
import CompatibilityImei from '../CompatibilityImei.vue';
export default {
    name: 'tipoSim',
    props: {
        compatModeActivator: {
            type: String,
            default: 'link-like'
        },
        compatibilidadLabel: {
            type: String,
            default: 'Verificar compatibilidad'
        },
        header: {
            type: String,
            default: 'Cantidad y tipo de SIM'
        }
    },
    components: {
        CompatibilityImei
    },
    data() {
        return {
            form: contrataYa.workingData,
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';
#tipo-sim {

    .link-like {
        cursor: pointer;
        color: $accent;
        text-decoration: underline;
    }

    .number-of-lines-holder {
        max-width: 20em;

        input {
            text-align: center;
        }
    }
}
</style>